import React from 'react';
import { SketchPicker } from 'react-color';

interface Props {
	value: string;
	onInputClick: () => void;
	displayColorPicker: boolean;
	colorPickerClose: () => void;
	colorChange: (color) => void;
}

export const WidgetColorPicker = (props: Props): React.ReactElement => {
	const { value, onInputClick, displayColorPicker, colorPickerClose, colorChange } = props;

	return (
		<>
			<div
				style={{ background: `${value}` }}
				className="color-wrapper__example position-absolute cursor-pointer"
				onClick={onInputClick}
			/>

			{
				displayColorPicker ? (
					<div className="position-absolute colorPicker">
						<div
							className="colorPicker-background"
							onClick={colorPickerClose}
						/>
						{/*@ts-ignore*/}
						<SketchPicker
							color={value}
							onChange={colorChange}
							disableAlpha={true}
						/>
					</div>
				) : null
			}
		</>
	);
};
